// extracted by mini-css-extract-plugin
module.exports = {"footer_wrapper":"Footer_footer_wrapper__2wk2F"};